import { Field, Form, Formik } from 'formik';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import BackButton from '../../components/BackButton';
import { FloatingPlaceholder } from '../../components/FloatingPlaceholder';
import { Loader } from '../../components/Loader';
import { SubmitButton } from '../../components/SubmitButton';
import { EVO } from '../../EVO';
import * as actions from '../../redux/clinics';
import { urls } from '../../urls';

class ClinicDetails extends Component {
    componentDidMount() {
        this.props.fetchclinics(this.props);
    }

    save = (values, { setSubmitting }) => {
        this.props.addOrUpdateItem(values)
            .finally(() => {
                setSubmitting(false);
                EVO.updateIdFromNew(this.props, this.props.clinic, urls.router.clinics.index.url);
            });
    }

    renderDetails() {
        return null;// this.props.id ? <ClinicChores /> : null;
    }

    render() {
        return (
            <div>
                <Loader loading={this.props.loading && this.props.clinic}>
                    <h1>{this.props.clinic.name || 'Add new'}</h1>
                    <BackButton />
                    <Formik
                        initialValues={this.props.clinic}
                        onSubmit={this.save}>
                        {({ isSubmitting }) => (
                            <Form>
                                <Field type="text" name="name" component={FloatingPlaceholder} placeholder="Name" />
                                <SubmitButton type="submit" disabled={isSubmitting} classNames={{ 'loading': isSubmitting }} text={this.props.id ? "Update Details" : "Create Clinic"} />
                            </Form>
                        )}
                    </Formik>
                    {this.renderDetails()}
                </Loader>
            </div>
        );
    }
}

const mapStateToProps = ({ clinics }) => ({
    clinic: clinics.clinic,
    loading: clinics.loading,
    error: clinics.error,
    id: clinics.id
});

export default connect(mapStateToProps, actions)(withRouter(ClinicDetails));


// WEBPACK FOOTER //
// ./src/pages/Clinics/ClinicDetails.js